<div class="tw-flex tw-text-[#7B7575] tw-text-[16px] tw-leading-6 tw-mb-[8px]">
    {{ label | translate }}
    <span class="tw-text-red-400 tw-ml-[5px]" *ngIf="mandatoryField === true"
        >*</span
    >
</div>
<div
    class="borderCss {{
        'tw-relative select-home-container tw-w-full tw-bg-white tw-px-[24px] tw-rounded-[16px] tw-py-[15px] ' +
            (errors.length > 0 ? 'errorBorderCss ' : '') +
            (classOverrides !== null ? ' ' + classOverrides : '') +
            (backgroundOverride ? backgroundOverride : '') +
            (isFocus == true ? ' focusedBorderCss ' : '')
    }}
    "
    [ngClass]="
        !applyDisableText
            ? 'tw-bg-white tw-text-black'
            : 'tw-text-black/[0.40] '
    "
>
    <label
        class="tw-hidden tw-flex tw-gap-2 tw-items-center tw-text-[12px] tw-leading-[18px] tw-font-[500] tw-text-gray-400 {{
            headerUnderline ? 'tw-underline' : ''
        }}"
        *ngIf="label !== null"
    >
        <div>
            {{ label | translate }}
            <span class="tw-text-red-400" *ngIf="mandatoryField === true"
                >*</span
            >

            <div
                *ngIf="TooltipData.header !== ''"
                class="tw-relative tw-bottom-[160%] -tw-right-5 md:tw-top-[180%] md:-tw-translate-y-[50%] md:tw-left-32 tw-w-[277px] md:tw-w-[277px]"
            >
                <app-tooltip
                    [showInfoTooltip]="tooltipDataHeading"
                    [tooltipData]="TooltipData"
                ></app-tooltip>
            </div>
        </div>
        <span *ngIf="TooltipData.header == '' && tooltipDataHeading">
            <button
                mat-raised-button
                matTooltip="{{ tooltipDataHeading.content | translate }}"
                class="tw-h-full tw-place-items-center"
            >
                <mat-icon
                    class="outlined-icon tw-scale-50 tw-padding-top-[10px]"
                    >info_outline</mat-icon
                >
            </button>
        </span>
    </label>
    <div class="tw-flex tw-items-center tw-justify-between">
        <div
            class="tw-flex tw-w-full"
            *ngIf="phoneNoCodeLabel !== undefined; else normalInput"
        >
            <input
                *ngIf="phoneNoCodeLabel !== undefined"
                class="tw-text-[14px] xl:tw-text-[16px] tw-max-w-[40px] tw-font-semibold disabled:tw-bg-transparent"
                [ngClass]="
                    !applyDisableText
                        ? 'tw-bg-white tw-text-black'
                        : 'tw-text-black/[0.40]'
                "
                value="{{ phoneNoCodeLabel }}"
                disabled
                appForbiddenChars
            />

            <input
                [type]="hide ? 'password' : inputType"
                [formControlName]="
                    controlName !== undefined ? controlName : null
                "
                class="tw-w-full tw-text-[14px] xl:tw-text-[16px] tw-ml-2 tw-font-semibold disabled:tw-bg-transparent"
                [ngClass]="[
                    applyDisableText ? 'tw-text-black/[0.40]' : 'tw-text-black',
                    !applyDisableText ? 'tw-bg-white' : ''
                ]"
                placeholder="{{ placeHolder }}"
                (click)="hideTooltip()"
                appForbiddenChars
            />
        </div>

        <ng-template #normalInput>
            <input
                [type]="hide ? 'password' : inputType"
                [formControlName]="
                    controlName !== undefined ? controlName : null
                "
                [class]="
                    'tw-text-[14px] xl:tw-text-[16px] tw-leading-[32px] ' +
                    (applyDisableText
                        ? 'tw-text-black/[0.40]'
                        : 'tw-text-black') +
                    ' placeholder:tw-text-black/[0.40] tw-font-[500] md:tw-leading-[28px] lg:tw-leading-[32px] tw-w-full ' +
                    (backgroundOverride ? backgroundOverride : '')
                "
                placeholder="{{ placeHolder }}"
                [maxlength]="maxlength"
                (click)="hideTooltip()"
                (focus)="onFocus()"
                (blur)="onBlur()"
                appForbiddenChars
        /></ng-template>

        <mat-icon
            *ngIf="removeValue && currentValue.length > 0"
            class="placeholder tw-mt-[-17px] tw-cursor-pointer"
            (click)="removeValueHandler()"
            >cancel</mat-icon
        >

        <mat-icon
            *ngIf="hideInput"
            class="tw-cursor-pointer"
            [ngStyle]="{
                'margin-top': label === null ? '-5px' : '-17px'
            }"
            (click)="toggleHideInput()"
            >{{ hide ? "visibility_off" : "visibility" }}</mat-icon
        >
        <button
            *ngIf="resetPasswordButton"
            (click)="resetPass()"
            class="tw-bg-[#FFE5CC] tw-font-semibold tw-py-2 tw-px-4 tw-rounded-full"
        >
            {{ "COMMON.RESET" | translate }}
        </button>

        <button
            *ngIf="verifyButton"
            [disabled]="disableCompanyRegVerifyBtn"
            (click)="toggleVerifyButton()"
            class="tw-flex tw-m-auto tw-items-center tw-font-semibold tw-text-xs tw-py-2 tw-px-4 tw-rounded-full tw-max-h-[34px] tw-bg-[#FFE5CC] tw-max-w-[72px]"
        >
            <span class="buttonAlignment">
                <span class="tw-ml-1">{{
                    "NEW_APPLICATION.VERIFY" | translate
                }}</span>
            </span>
        </button>

        <button
            *ngIf="buttonVerified"
            (click)="onBRNVerified()"
            class="tw-flex tw-m-auto tw-items-center tw-font-semibold tw-text-xs tw-py-2 tw-px-4 tw-rounded-full tw-max-h-[34px] tw-text-[#4B6EEC] tw-max-w-[100px]"
        >
            <span class="buttonAlignment">
                <img
                    class="tw-w-[26px] tw-h-auto md:tw-h-[26px]"
                    src="/assets/images/verified.png"
                    alt="Verified"
                />
            </span>
        </button>

        <!-- identification no verify -->
        <button
            [disabled]="disableIdentificationVerifyBtn"
            *ngIf="verifyIdentificationNoBtn"
            (click)="toggleIdentificationVerifyButton()"
            class="tw-flex tw-m-auto tw-items-center tw-font-semibold tw-text-xs tw-py-2 tw-px-4 tw-rounded-full tw-max-h-[34px] tw-max-w-[72px] tw-bg-[#FFE5CC]"
        >
            <span class="buttonAlignment">
                <span class="tw-ml-1">{{
                    "NEW_APPLICATION.VERIFY" | translate
                }}</span>
            </span>
        </button>

        <button
            *ngIf="identificationNoButtonVerified"
            (click)="onKYCVerified()"
            class="tw-flex tw-m-auto tw-items-center tw-font-semibold tw-text-xs tw-py-2 tw-px-4 tw-rounded-full tw-max-h-[34px] tw-max-w-[100px] tw-text-[#4B6EEC]"
        >
            <span class="buttonAlignment">
                <img
                    class="tw-w-[26px] tw-h-auto md:tw-h-[26px]"
                    src="/assets/images/verified.png"
                    alt="Verified"
                />
            </span>
        </button>

        <mat-spinner
            *ngIf="verifyCompanyRegNoLoading"
            [diameter]="30"
            style="margin-top: 0px"
        ></mat-spinner>

        <mat-spinner
            *ngIf="verifyIdentificationNoLoading"
            [diameter]="30"
            style="margin-top: 0px"
        ></mat-spinner>

        <!-- identificationNo verify ends -->
        <button
            *ngIf="resetMobileButton"
            (click)="resetMobilePhone()"
            class="tw-bg-[#FFE5CC] tw-font-semibold tw-text-[12px] md:tw-text-[16px] tw-py-2 tw-px-4 tw-rounded-full"
        >
            {{ "COMMON.CHANGE" | translate }}
        </button>
        <button
            *ngIf="verifyMobileButton"
            type="button"
            (click)="verifyMobileNo()"
            class="tw-bg-[#FFE5CC] tw-font-semibold tw-text-[12px] md:tw-text-[16px] tw-py-2 tw-px-4 tw-rounded-full"
        >
            {{ "NEW_APPLICATION.VERIFY" | translate }}
        </button>
    </div>
</div>

<div *ngIf="errors.length > 0" class="tw-flex tw-flex-col tw-mt-4">
    <div
        *ngFor="let error of errors; let i = index"
        class="tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
    >
        <mat-icon class="error-icon !tw-overflow-visible"
            >error_outline</mat-icon
        >

        <span
            [ngClass]="{
                'tw-border-b tw-pt-3 tw-pb-3 tw-border-gray-200':
                    i !== errors.length - 1
            }"
            >{{ error }}</span
        >
    </div>
</div>

<div *ngIf="strength !== null" class="tw-flex tw-mt-4 tw-gap-4">
    <div
        *ngFor="let no of strengthArray; let i = index"
        class="tw-bg-white tw-h-[4px] tw-flex-1 tw-rounded-[3rem]"
        [ngStyle]="{
            'background-color': i < strength ? strengthColor : 'transparent'
        }"
    ></div>
</div>

<div
    class="tw-text-right tw-mt-2 tw-text-gray-500"
    *ngIf="strengthLabel !== null"
>
    {{ strengthLabel }}
</div>
